import {
  COMMON_NAMESPACE,
  CONTACT_TOC_FOOTER,
} from "constants/i18n-namespaces";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IBiller, IContactInfoProperties } from "types/biller";
import Modal from "react-modal";
import Sheet from "react-modal-sheet";
import XButton from "assets/icons/x_button.svg";
import { TextButton } from "kubra-ux-forge";
import { customStyles } from "constants/customStyles";
import { useSelector } from "react-redux";
import { getBiller } from "selectors";
import { IExternalLinksProperties } from "types/biller";
import { ContactModal } from "../contact-modal";
import { phoneFormat } from "utilities/helper";
import { getIsMobile } from "selectors/appState";
import { KUBRA_TERMS_OF_USE_URL } from "constants/externalUrls";

interface ContactAndTocFooterProps {
  biller?: IBiller;
}

export const ContactAndTocFooter = ({ biller }: ContactAndTocFooterProps) => {
  const { t } = useTranslation(CONTACT_TOC_FOOTER);
  const [showContactUsModal, setShowContactUsModal] = useState(false);
  const finalBiller = useSelector(getBiller);
  const externalLinks = finalBiller?.properties?.find(
    (element) => element.name === "ExternalLinks",
  )?.properties as IExternalLinksProperties;
  const isMobile = useSelector(getIsMobile);

  const termsAndConditionsLink = externalLinks?.termsAndConditions;

  const contactUs = biller?.properties?.find((element) => {
    return element.name === "InstanceConfiguration";
  })?.properties as IContactInfoProperties;

  return (
    <>
      <div
        className={
          biller?.featureFlags?.payableUi?.toLowerCase() === "true"
            ? "toc-payable-footer-links-container"
            : "toc-footer-links-container"
        }
      >
        <div>
          <span className="need-help-text">{t("need-help")}&nbsp;</span>
          <TextButton
            hoverStyle="underline"
            onClick={() => setShowContactUsModal(true)}
            className="contact-us-text"
            data-testid="contact-us-text"
            dataCy="button-contact-us"
          >
            {t("contact-us")}
          </TextButton>
        </div>
        <div>
          <TextButton
            hoverStyle="underline"
            onClick={() => {
              termsAndConditionsLink
                ? window.open(termsAndConditionsLink, "_blank")
                : window.open(
                    KUBRA_TERMS_OF_USE_URL,
                    "_blank",
                    "noopener,noreferrer",
                  );
            }}
            className="terms-text"
            data-testid="term-conditions-text"
            dataCy="button-terms-and-conditions"
          >
            {t("term-and-conditions")}
          </TextButton>
        </div>
      </div>
      {isMobile && (
        <Sheet
          isOpen={showContactUsModal}
          onClose={() => setShowContactUsModal(false)}
          detent="content-height"
          disableDrag={true}
          aria-labelledby="contact-toc-modal-header-mobile"
        >
          <Sheet.Container>
            <Sheet.Header>
              <div className="react-modal-sheet-header heading-style-override">
                <h2
                  className="help-modal-header-text"
                  id="contact-toc-modal-header-mobile"
                >
                  {t("contact")} {biller?.billerName ?? t("us")}
                </h2>
                <button
                  className="modal-close"
                  onClick={() => setShowContactUsModal(false)}
                  aria-label={`${t("close-modal", { ns: COMMON_NAMESPACE })}}`}
                  data-cy="modal-close-x-contact-toc"
                >
                  <img
                    src={XButton}
                    alt={`${t("close-modal", { ns: COMMON_NAMESPACE })}}`}
                    className="modal-close-x"
                  />
                </button>
              </div>
            </Sheet.Header>
            <Sheet.Content>
              <ContactModal
                contactPhone={phoneFormat(contactUs?.phone ?? "")}
                contactEmail={contactUs?.email ?? ""}
                contactAddress={contactUs?.street ?? ""}
                contactCity={contactUs?.city ?? ""}
                contactState={contactUs?.state ?? ""}
                contactZip={contactUs?.zipCode ?? ""}
                contactWebsite={contactUs?.website ?? ""}
              />
            </Sheet.Content>
          </Sheet.Container>
          {/*@ts-ignore*/}
          <Sheet.Backdrop onClick={() => setShowContactUsModal(false)} />
        </Sheet>
      )}
      {!isMobile && (
        /* @ts-ignore */
        <Modal
          isOpen={showContactUsModal}
          ariaHideApp={false}
          className="modal-frame-help"
          shouldCloseOnOverlayClick={true}
          onRequestClose={() => setShowContactUsModal(false)}
          style={customStyles}
          aria={{
            labelledby: "contact-toc-modal-header",
          }}
        >
          <div className="modal-header heading-style-override">
            <h2
              className="help-modal-header-text"
              id="contact-toc-modal-header"
            >
              {t("contact")} {biller?.billerName ?? t("us")}
            </h2>
            <button
              className="modal-close"
              onClick={() => setShowContactUsModal(false)}
              aria-label={`${t("close-modal", { ns: COMMON_NAMESPACE })}}`}
              data-cy="modal-close-x-contact-toc"
            >
              <img
                src={XButton}
                alt={`${t("close-modal", { ns: COMMON_NAMESPACE })}}`}
                className="modal-close-x"
              />
            </button>
          </div>

          <ContactModal
            contactPhone={phoneFormat(contactUs?.phone ?? "")}
            contactEmail={contactUs?.email ?? ""}
            contactAddress={contactUs?.street ?? ""}
            contactCity={contactUs?.city ?? ""}
            contactState={contactUs?.state ?? ""}
            contactZip={contactUs?.zipCode ?? ""}
            contactWebsite={contactUs?.website ?? ""}
          />
        </Modal>
      )}
    </>
  );
};
